<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>
          {{
              tipoComprobante === codigoFactura
                ? "Factura"
                : tipoComprobante === codigoNotaCredito
                  ? "Nota de crédito"
                  : tipoComprobante === codigoProforma
                    ? "Proforma"
                    : "Nota de venta"
          }}
          {{ numero_comprobante }}
        </h3>
        <label>
          <div v-show="estado === 'PPR' && anulado === 'N'" class="noti-warning">
            <strong>PENDIENTE DE AUTORIZACIÓN</strong>
          </div>
          <div v-show="anulado === 'S'" class="noti-danger">
            <strong>ANULADO</strong>
          </div>
          <div v-show="
            (estado === undefined || estado === null) &&
            anulado === 'N' &&
            !enColaAutorizacion
          " class="noti-info">
            <strong>EMITIDO</strong>
          </div>
          <div v-show="estado === 'AUT' && anulado === 'N'" class="noti-success">
            <strong>AUTORIZADO</strong>
          </div>
          <div v-show="estado === 'N' && anulado === 'N'" class="noti-secondary">
            <strong>NUEVO</strong>
          </div>
          <div v-show="estado === 'NAT' && anulado === 'N'" class="noti-danger">
            <strong>NO AUTORIZADO</strong>
          </div>
          <div v-show="enColaAutorizacion" class="noti-primary">
            <strong>PENDIENTE DE ENVÍO AL SRI</strong>
          </div>
        </label>
      </div>
      <div class="layout__controls">
        <form @submit="submitFoto" :action="url + '/subir-comprobante-venta/' + id_comprobante" method="POST"
          enctype="multipart/form-data" class="form-inline">
          <input v-show="estado !== 'N' && anulado !== 'S'" type="file" name="path_foto" id="path_foto" />
          <input type="hidden" name="_token" :value="token" />
          <button v-show="estado !== 'N' && anulado !== 'S'" type="submit" class="btn-success btn--bigger">
            <i class="fa fa-upload"></i><span>Subir</span>
          </button>
          <button @click="descargarArchivo" v-show="estado !== 'N' && path_foto != '' && path_foto != null"
            type="button" class="btn-info btn--bigger">
            <i class="fa fa-download"></i><span>Ver documento(s)</span>
          </button>
          <button :disabled="!permiteEliminarComprobante && !permiteEditarComprobante" @click="consultarComprobantes"
            class="btn-bus200 btn--bigger" type="button">
            <i class="fa fa-search"></i>
            <span>Buscar comprobantes</span>
          </button>
        </form>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información del comprobante</h5>
            <div class="card__controls">
              <p v-show="(tipoComprobante === codigoFactura && !datos_factura_resumida)">
                <label for="factura_exterior">
                  <input type="checkbox" name="factura_exterior" id="factura_exterior" v-model="form.factura_exterior"><span>Factura del Exterior</span>
                </label>
              </p>
            </div>
          </div>
          <div class="card__content">
            <div class="row">
              <div v-show="
                tipoComprobante === codigoNotaCredito ||
                (tipoComprobante === codigoFactura && !datos_factura_resumida)
              " class="col-xs-12 col-md-6">
                <div class="form-field">
                  <div class="form-group">
                    <input-field readonly v-model="form.numero_comprobante_afectado" type="tel"
                      v-mask="'###-###-#########'" id="comprobanteAfectado" placeholder="N° comprobante">
                      <span>{{
                          tipoComprobante === codigoFactura
                            ? "Proforma"
                            : "Comprobante afectado"
                      }}</span>
                    </input-field>
                    <button :disabled="!editable" v-show="form.tipo_comprobante_afectado === ''" class="btn-info"
                      type="button" @click="consultarComprobantesVenta">
                      <i class="fa fa-search"></i>
                    </button>
                    <button :disabled="!editable" @click="quitarComprobanteAfectado"
                      v-show="form.tipo_comprobante_afectado !== ''" class="btn-danger">
                      <i class="fa fa-ban"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div v-show="
                tipoComprobante === codigoNotaCredito ||
                (tipoComprobante === codigoFactura && !datos_factura_resumida)
              " class="col-xs-12 col-md-6">
                <div class="form-field">
                  <div class="datepicker-field">
                    <VueCtkDateTimePicker disabled id="fecha_emision_comprobante_afectado"
                      v-model="form.fecha_emision_comprobante_afectado" locale="es" no-label only-date auto-close
                      button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                      label="Seleccione una fecha..." />
                    <label for="fecha_emision_comprobante_afectado">Fecha de emisión del comprobante *</label>
                    <span v-if="errores.fecha_emision_comprobante_afectado" class="helper-text text-danger"
                      slot="helper">
                      <strong>{{
                          errores.fecha_emision_comprobante_afectado[0]
                      }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="estado == 'N'" class="col-xs-12 col-md-4">
                <div class="form-field select2" :class="{ 'select2--disabled': estado !== 'N' }">
                  <div class="form-group">
                    <div class="select2-field">
                      <v-select @input="inputPuntoEmision" label="descripcion" :options="puntosEmision" v-model="selectedPuntoEmision"
                        id="punto_emision" placeholder="Seleccione..."></v-select>
                      <label for="punto_emision">Punto de emisión *</label>
                      <span v-if="errores.id_punto_emision" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.id_punto_emision[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="
                tipoComprobante !== '00' && !esElectronico && estado === 'N'
              " class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field v-mask="'#########'" type="tel" id="numero_documento" v-model="form.numero_documento"
                    placeholder="#########">
                    <span>Número de documento</span>
                    <span v-if="errores.numero_documento" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.numero_documento[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-group">
                    <input-field v-model="numero_identificacion" :readonly="
                      (form.id_cliente !== null && form.id_cliente !== '') ||
                      (tipoComprobante !== codigoFactura &&
                        tipoComprobante !== codigoProforma &&
                        tipoComprobante !== codigoNotaVenta)
                    " id="identificacion" placeholder="# Identificación">
                      <span>Identificación *</span>
                      <span v-if="errores.id_cliente" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.id_cliente[0] }}</strong>
                      </span>
                    </input-field>
                    <button :disabled="!editable" @click="consultarCliente" v-show="
                      (form.id_cliente === null || form.id_cliente === '') &&
                      (tipoComprobante === codigoFactura ||
                        tipoComprobante === codigoProforma ||
                        tipoComprobante === codigoNotaVenta)
                    " type="button" class="btn-success">
                      <i class="fa fa-check"></i>
                    </button>
                    <button :disabled="!editable" @click="quitarCliente" v-show="
                      form.id_cliente !== null &&
                      form.id_cliente !== '' &&
                      (tipoComprobante === codigoFactura ||
                        tipoComprobante === codigoProforma ||
                        tipoComprobante === codigoNotaVenta)
                    " type="button" class="btn-danger">
                      <i class="fa fa-ban"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-group">
                    <input-field v-model="nombre_cliente" readonly id="cliente" placeholder="Nombre de cliente">
                      <span>Cliente *</span>
                    </input-field>
                    <button :disabled="!editable" v-show="
                      tipoComprobante === codigoFactura ||
                      tipoComprobante === codigoProforma ||
                      tipoComprobante === codigoNotaVenta
                    " @click="consultarPersonas" type="button" class="btn-info">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <date-picker @keyup.native="actualizarFechaVencimiento" :disabled="!editable"
                      v-model="form.fecha_emision" type="date" format="dd-MM-yyyy" id="fecha_emision" lang="es">
                    </date-picker>
                    <label for="fecha_emision">Fecha de emisión *</label>
                    <span v-if="errores.fecha_emision" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.fecha_emision[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field :disabled="!editable" v-model="form.email" id="email" placeholder="Correo del cliente">
                    <span>E-mail ("," para separar varios)</span>
                    <span v-if="errores.email" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.email[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div v-show="tipoComprobante !== '00' && !datos_factura_resumida" class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field v-model="clave_acceso" readonly id="clave_acceso" placeholder="################">
                    <span>Clave de acceso</span>
                  </input-field>
                </div>
              </div>
              <div v-show="tipoComprobante !== '00' && !datos_factura_resumida" class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <date-picker v-model="form.fecha_autorizacion" disabled type="datetime" format="dd-MM-yyyy HH:mm:ss"
                      id="fecha_autorizacion" lang="es"></date-picker>
                    <label for="fecha_autorizacion">Fecha de autorización *</label>
                  </div>
                </div>
              </div>
              <div v-show="tipoComprobante !== '00' && !datos_factura_resumida" class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field v-model="form.numero_autorizacion" readonly placeholder="#############"
                    id="numero_autorizacion">
                    <span>N° Autorización</span>
                  </input-field>
                </div>
              </div>
              <div v-show="tipoComprobante !== '00' && !datos_factura_resumida" class="col-xs-12 col-md-4">
                <div class="form-field select2" :class="{
                  'select2--disabled':
                    tipoComprobante !== codigoFactura ||
                    tipoComprobante !== codigoProforma ||
                    tipoComprobante !== codigoNotaVenta ||
                    !editable,
                }">
                  <div class="select2-field">
                    <v-select label="descripcion" :options="monedas" v-model="selectedMoneda" id="moneda"
                      placeholder="Seleccione..."></v-select>
                    <label for="moneda">Moneda *</label>
                    <span v-if="errores.id_moneda" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.id_moneda[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div :class="{
                  'select2--disabled':
                    tipoComprobante === codigoNotaCredito || !editable,
                }" class="form-field select2">
                  <div class="select2-field">
                    <v-select label="nombre" :options="vendedores" v-model="selectedVendedor" id="vendedor"
                      placeholder="Seleccione..."></v-select>
                    <label for="vendedor">Vendedor *</label>
                    <span v-if="errores.vendedor_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.vendedor_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4" v-show="tipoComprobante === codigoNotaCredito">
                <div :class="{ 'select2--disabled': !editable }" class="form-field select2">
                  <div class="select2-field">
                    <v-select v-model="form.selectedMotivo" :options="motivos" id="motivo"></v-select>
                    <label for="motivo">Motivo *</label>
                    <span v-if="errores.selectedMotivo" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.selectedMotivo[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4" v-show="tipoComprobante === codigoNotaCredito">
                <div class="form-field">
                  <input-field :disabled="!editable" v-model="form.motivo" id="descripcionMotivo"
                    placeholder="Escriba el motivo...">
                    <span>Descripción del motivo</span>
                    <span v-if="errores.motivo" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.motivo[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div v-show="tipoComprobante == codigoFactura && !datos_factura_resumida" :class="{ 'col-xs-12 col-md-8': !moduloProyecto, 'col-xs-12 col-md-4': moduloProyecto }">
                <div class="form-field select">
                  <div class="form-group">
                    <div class="select2-field">
                      <v-select label="numero" multiple :options="form.compras" id="compras" v-model="form.compras"
                        placeholder="Seleccione..."></v-select>
                      <label for="compras">Compras</label>
                    </div>
                    <button @click="consultarCompras" type="button" class="btn-info">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div v-show="tipoComprobante == codigoFactura && moduloProyecto" class="col-xs-12 col-md-4">
                <div class="form-group">
                  <div class="select2-field">
                    <v-select
                      multiple
                      v-model="selectedProyectos"
                      @search="onSearchProyecto"
                      @input="inputProyecto"
                      id="proyecto_id"
                      placeholder="Busque y seleccione..."
                      label="nombre"
                      :options="optionProyectos"
                    ></v-select>
                    <label for="proyecto_id">Proyectos</label>
                  </div>
                  <button @click="consultarProyectos" type="button" class="btn-info">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
              <div class="col-xs-12 col-md-4" v-show="
                tipoComprobante === codigoFactura && referenciaOt !== ''
              ">
                <div class="form-group">
                  <div class="form-field">
                    <input-field id="referenciaOt" :value="referenciaOt" readonly>Orden de trabajo</input-field>
                  </div>
                  <button @click="verOt" type="button" class="btn-info btn--text">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
              </div>
              <div v-show="false" class="col-xs-12 col-md-4">
                <div class="form-field select2" :class="{
                  'select2--disabled':
                    tipoComprobante !== codigoFactura &&
                    tipoComprobante !== codigoProforma &&
                    tipoComprobante !== codigoNotaVenta,
                }">
                  <div class="select2-field">
                    <v-select label="descripcion" :options="tiposEmision" v-model="selectedTipoEmision"
                      id="tipo_emision" placeholder="Seleccione..."></v-select>
                    <label for="tipo_emision">Tipo de emisión *</label>
                    <span v-if="errores.id_tipo_emision" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.id_tipo_emision[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="form.factura_exterior" class="col-xs-12 col-md-4">
                <div class="form-field select">
                  <div class="select-field">
                    <select name="incoterm_factura" v-model="form.incoterm_factura" 
                    id="incoterm_factura">
                      <option value="">Seleccione...</option>
                      <option :value="tipo" v-for="tipo in tiposIncoterm" :key="tipo">
                        {{ tipo }}
                      </option>
                    </select>
                    <label for="incoterm_factura">Incoterm Factura</label>
                    <span v-if="errores.incoterm_factura" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.incoterm_factura[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="form.factura_exterior" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select placeholder="Seleccione..." label="descripcion" @input="inputProvincia" v-model="selectedProvincia" id="prov_incoterm_id" :options="provincias"></v-select>
                    <label for="prov_incoterm_id">Provincia</label>
                    <span v-if="errores.prov_incoterm_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.prov_incoterm_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="form.factura_exterior" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select placeholder="Seleccione..." label="descripcion" @input="inputCiudad" v-model="selectedCiudad" id="lug_incoterm_id" :options="ciudades"></v-select>
                    <label for="lug_incoterm_id">Lugar Incoterm</label>
                    <span v-if="errores.lug_incoterm_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.lug_incoterm_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="form.factura_exterior" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select placeholder="Seleccione..." label="descripcion" @input="inputProvinciaEmbarque" v-model="selectedProvEmbarque" id="prov_embarque_id" :options="provincias"></v-select>
                    <label for="prov_embarque_id">Provincia de Embarque</label>
                    <span v-if="errores.prov_embarque_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.prov_embarque_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="form.factura_exterior" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select placeholder="Seleccione..." label="descripcion" @input="inputCiudadEmbarque" v-model="selectedCiudadEmbarque" id="pue_embarque_id" :options="ciudadesEmbarque"></v-select>
                    <label for="pue_embarque_id">Puerto de Embarque</label>
                    <span v-if="errores.pue_embarque_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.pue_embarque_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="form.factura_exterior" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select label="descripcion" placeholder="Seleccione..." @input="inputPais" v-model="selectedPais" name="pais_adquisicion_id" :options="paises" id="pais_adquisicion_id"></v-select>
                    <label for="pais_adquisicion_id">País de Adquisición</label>
                    <span v-if="errores.pais_adquisicion_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.pais_adquisicion_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="form.factura_exterior" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select placeholder="Seleccione..." label="descripcion" @input="inputProvinciaDestino" v-model="selectedProvDestino" id="prov_destino_id" :options="provinciasDestino"></v-select>
                    <label for="prov_destino_id">Provincia de Destino</label>
                    <span v-if="errores.prov_destino_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.prov_destino_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="form.factura_exterior" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select placeholder="Seleccione..." label="descripcion" @input="inputPuertoDestino" v-model="selectedPuertoDestino" id="pue_destino_id" :options="ciudadesDestino"></v-select>
                    <label for="pue_destino_id">Puerto de Destino</label>
                    <span v-if="errores.pue_destino_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.pue_destino_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div v-show="form.factura_exterior" class="col-xs-12 col-md-4">
                <div class="form-field select">
                  <div class="select-field">
                    <select name="incoterm_total_si" v-model="form.incoterm_total_si" 
                    id="incoterm_total_si">
                      <option value="">Seleccione...</option>
                      <option :value="tipo" v-for="tipo in tiposIncoterm" :key="tipo">
                        {{ tipo }}
                      </option>
                    </select>
                    <label for="incoterm_total_si">Incoterm Total S/I</label>
                  </div>
                </div>
              </div>
              <div v-if="no_anular_consumidor_final_aut" class="col-xs-12">
                <div class="noti-info">
                  <p> 
                    <i class="fa fa-info-circle"></i>
                    Recuerda enviar tus comprobantes electrónicos el mismo día de su emisión para evitar sanciones. según lo establece la resolución NAC-DGERCGC25-00000014.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-0">
          <div class="card__title">
            <h5>Detalles del comprobante</h5>
            <!-- <div class="form-inline my-0" style="
              --input-gap: 0;
              --_input-min-width: 300px;
              --_input-border-top-left-radius: 0;
              --_input-border-bottom-left-radius: 0;
              --_label-padding-inline: .3rem;
              --_label-border-color: var(--gray-500);
              --_label-border-style: solid;
              --_label-border-inline: 1px 0;
              --_label-border-block: 1px;
              --_label-border-top-left-radius: var(--border-radius-base);
              --_label-border-bottom-left-radius: var(--border-radius-base);
              --_flex-direction: row-reverse;
            ">
              <input-field v-show="!datos_factura_resumida" stretch id="searchItems" v-model="searchItems"
                placeholder="Consulta de detalle por descripción..." class="my-0">
                <span><i class="fa fa-search"></i></span>
              </input-field>
            </div> -->
            <div class="card__controls">
              <div class="form-field select2 my-0">
                <div class="select2-field">
                  <v-select placeholder="Seleccione un item..." id="item" v-model="selectedItem" @search="onSearchItems"
                    :options="items" label="descripcion_item" @input="inputItem"></v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="card__content">
            <tabla-detalle-comprobante :iva_incluido_exp="iva_incluido_exp" :factura_exterior="form.factura_exterior" ref="tablaDetalleComprobante" :retencionProductos="retencionProductos"
              :retencionServicios="retencionServicios" :precioEditable="permiteEditarPrecio" tipo="E"
              :disabled="!editable" :anulado="anulado" :tipoComprobante="tipoComprobante" :errores="errores"
              @input="inputDetalles" v-model="form.items" :irbpnr="irbpnr" :search="searchItems"
              :decimales_compras="precision"></tabla-detalle-comprobante>
          </div>
        </div>
        <div v-show="form.factura_exterior" class="card">
          <div class="card__title">
            <h5>Datos de Exportación</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-3">
                <div class="form-field">
                  <input-field @keyup.native="calcularTotales" id="v_flete_internacional" v-model="form.v_flete_internacional" vMoney :format="money">
                    <span>Valor de Flete Internacional</span>
                    <span v-if="errores.v_flete_internacional" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.v_flete_internacional[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-3">
                <div class="form-field">
                  <input-field @keyup.native="calcularTotales" id="v_seguro_internacional" v-model="form.v_seguro_internacional" vMoney :format="money">
                    <span>Valor de Seguro Internacional</span>
                    <span v-if="errores.v_seguro_internacional" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.v_seguro_internacional[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-3">
                <div class="form-field">
                  <input-field @keyup.native="calcularTotales" id="v_gastos_aduaneros" v-model="form.v_gastos_aduaneros" vMoney :format="money">
                    <span>Valor de Gastos Aduanero</span>
                    <span v-if="errores.v_gastos_aduaneros" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.v_gastos_aduaneros[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-3">
                <div class="form-field">
                  <input-field @keyup.native="calcularTotales" id="v_gastos_transporte_otros" v-model="form.v_gastos_transporte_otros" vMoney :format="money">
                    <span>Valor de Gastos de Otros Transportes</span>
                    <span v-if="errores.v_gastos_transporte_otros" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.v_gastos_transporte_otros[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-0" v-show="
          (tipoComprobante === codigoFactura) ||
          tipoComprobante === codigoNotaVenta
        ">
          <div class="card__title">
            <h5>Forma de pago</h5>
          </div>
          <div class="card__content">
            <tabla-forma-pago @updatedFormaPago="inputFormasPago" :tiposUnidad="tiposUnidad" :disabled="!editable"
              :totalComprobante="form.total" :errores="errores" :formasPago="formasPago" v-model="form.formasPago"
              :formaPagoIdDefault="formaPagoIdDefault"
            >
            </tabla-forma-pago>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-7">
            <div class="card">
              <div class="card__title">
                <h5>Información adicional</h5>
              </div>
              <div class="card__content">
                <tabla-informacion-adicional enviable :disabled="!editable" :errores="errores"
                  v-model="form.informacionAdicional"></tabla-informacion-adicional>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-5">
            <div class="card">
              <div class="card__title">
                <h5>Totales del comprobante</h5>
              </div>
              <div class="card__content">
                <div class="row">
                  <div class="col-xs-12 col-lg-6">
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.total_sin_impuestos" id="subtotal_sin_impuestos"
                        placeholder="$ #,###.##" readonly>
                        Subtotal S/I
                        <span v-if="errores.total_sin_impuestos" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.total_sin_impuestos[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.descuento_total" id="descuento_total"
                        placeholder="$ #,###.##" readonly>
                        Descuento total
                        <span v-if="errores.descuento_total" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.descuento_total[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.subtotal_no_sujeto_iva" id="subtotal_no_iva"
                        placeholder="$ #,###.##" readonly>
                        Subtotal N/IVA
                        <span v-if="errores.subtotal_no_sujeto_iva" class="helper-text text-danger" slot="helper">
                          <strong>{{
                              errores.subtotal_no_sujeto_iva[0]
                          }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.subtotal_exento_iva" id="subtotal_e_iva"
                        placeholder="$ #,###.##" readonly>
                        Subtotal E/I
                        <span v-if="errores.subtotal_exento_iva" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.subtotal_exento_iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.total_irbpnr" id="total_irbpnr"
                        placeholder="$ #,###.##" readonly>
                        Total IRBPNR
                        <span v-if="errores.total_irbpnr" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.total_irbpnr[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-lg-6">
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.subtotal_iva" id="subtotal_iva"
                        placeholder="$ #,###.##" readonly>
                        Subtotal IVA
                        <span v-if="errores.subtotal_iva" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.subtotal_iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.subtotal_iva_0" id="subtotal_iva_0"
                        placeholder="$ #,###.##" readonly>
                        Subtotal IVA 0%
                        <span v-if="errores.subtotal_iva_0" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.subtotal_iva_0[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.iva" id="iva" placeholder="$ #,###.##" readonly>
                        IVA
                        <span v-if="errores.iva" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.ice" id="ice" placeholder="$ #,###.##" readonly>
                        ICE
                        <span v-if="errores.ice" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.ice[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field vMoney :format="money" v-model="form.total" id="total" placeholder="$ #,###.##"
                        readonly>
                        Total
                        <span v-if="errores.total" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.total[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button :disabled="
              (!permiteEditarComprobante && estado !== 'N') ||
              (estado === 'N' && !permiteCrearComprobante) ||
              enColaAutorizacion
            " v-show="estado !== 'PPR' && anulado !== 'S' && selectedPuntoEmision != null" @click="guardarComprobante" type="button"
              class="btn-success">
              <i class="fa fa-save"></i>
              <span>Guardar</span>
            </button>
            <button :disabled="!permiteCrearComprobante" @click="nuevoComprobante" type="button"
              class="btn-light btn--text">
              <i class="fa fa-plus"></i>
              <span>Nuevo</span>
            </button>
            <button :disabled="!permiteEliminarComprobante || anular_temporal || (no_anular_consumidor_final_aut && estado == 'AUT' && numero_identificacion == '9999999999999')" @click="anularComprobante"
              v-show="estado !== 'N' && anulado === 'N' && selectedPuntoEmision != null" type="button" class="btn-danger btn--text">
              <i class="fa fa-ban"></i>
              <span>Anular</span>
            </button>
            <button :disabled="!permiteEliminarComprobante" @click="enviarComprobantesAnulados"
              v-show="anulado === 'S' && estado === 'AUT' && esElectronico" type="button" class="btn-primary btn--text">
              <i class="fa fa-envelope"></i>
              <span>Enviar comprobante anulado</span>
            </button>
            <button @click="imprimirComprobante" v-show="estado !== 'N'" type="button" class="btn-bus200 btn--text">
              <i class="fa fa-print"></i>
              <span>Imprimir</span>
            </button>
            <button @click="imprimirPDF" v-show="estado !== 'N'" type="button" class="btn-danger btn--text">
              <i class="fa fa-file-pdf-o"></i>
              <span>RIDE</span>
            </button>
            <button @click="verAnterior" type="button" class="btn-primary btn--text">
              <i class="fa fa-toggle-left"></i>Anterior
            </button>
            <button @click="verSiguiente" type="button" class="btn-primary btn--text">
              <i class="fa fa-toggle-right"></i>Siguiente
            </button>
            <button v-show="
              estado === 'AUT' && (intento_correo || tipoComprobante === '00')
            " class="btn-info btn--text" type="button" @click="enviarCorreo">
              <i class="fa fa-envelope-o"></i>
              <span>Enviar correo</span>
            </button>
            <button v-show="
              estado !== 'N' &&
              tipoComprobante !== codigoProforma &&
              tipoComprobante !== codigoNotaVenta
            " @click="abrirLogs" type="button" class="btn-secondary btn--text">
              <i class="fa fa-file-o"></i>
              <span>Logs</span>
            </button>
            <button :disabled="!permiteAbonarFactura" v-show="
              id_comprobante !== '' &&
              (tipoComprobante === codigoFactura ||
                tipoComprobante === codigoNotaVenta)
            " @click="abrirAbonos" class="btn-dark btn--text">
              <i class="fa fa-money"></i>
              <span>Abonos</span>
            </button>
            <button @click="autorizar" v-show="
              estado !== 'N' &&
              (estado === undefined || estado === null) &&
              anulado === 'N' &&
              !enColaAutorizacion &&
              ((permiteAutorizarFactura && tipoComprobante === '01') ||
                (permiteAutorizarNc && tipoComprobante === '04'))
            " class="btn-primary btn--text">
              <i class="fa fa-paper-plane"></i>
              <span>Autorizar</span>
            </button>
            <button v-show="
              estado !== 'N' &&
              anulado === 'N' &&
              tipoComprobante === codigoFactura
            " @click="notificarDeuda" class="btn-danger btn--text" type="button">
              <i class="fa fa-flag"></i>
              <span>Notificar deuda</span>
            </button>
            <button v-show="
              estado !== 'N' && tipoComprobante === '01' && permiteClonar
            " @click="clonar" class="btn-primary btn--text">
              <i class="fa fa-clone"></i>
              <span>Clonar</span>
            </button>
            <button @click="generarGuia" class="btn-warning btn--text" type="button"
              v-show="estado !== 'N' && tipoComprobante === '01'">
              <i class="fa fa-file"></i>
              <span>Generar guía</span>
            </button>
            <button @click="mostrarAuditorias" class="btn-info btn--text" type="button" v-show="estado !== 'N'">
              <i class="fa fa-file"></i>
              <span>Auditorías</span>
            </button>
            <button @click="$modal.show('comprasAsignadas')" class="btn-info btn--text" type="button"
              v-show="form.compras.length > 0">
              <i class="fa fa-eye"></i>
              <span>Compras asignadas</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal width="85%" height="auto" scrollable name="listaComprobantes">
      <lista-comprobantes @selected="selectedComprobante" :tipoComprobante="tipoComprobanteConsulta">
      </lista-comprobantes>
    </modal>
    <modal width="55%" height="auto" name="listaPersonas" scrollable>
      <lista-personas tipoFiltro="C" :filterStatus="false" @selected="selectedPersona"></lista-personas>
    </modal>
    <modal :clickToClose="personaClosable" scrollable width="70%" height="auto" name="persona">
      <persona :idProforma="id_proforma" :correoPersona="form.email" :closable="personaClosable"
        :nombrePersona="nombre_cliente" tipoFiltro="C" :numeroIdentificacion="numero_identificacion"
        @saved="savedPersona" :searchButton="false"></persona>
    </modal>
    <modal name="listaAbonos" width="70%" height="auto" scrollable>
      <lista-abonos :idComprobante="id_comprobante"></lista-abonos>
    </modal>
    <modal width="70%" name="coincidenciaComprobantes" height="auto" scrollable>
      <coincidencia-comprobantes @seleccionar="seleccionarComprobanteAfectado"
        @cerrar="$modal.hide('coincidenciaComprobantes')" :comprobantes="comprobantesConsultados">
      </coincidencia-comprobantes>
    </modal>
    <modal width="50%" name="imprimir" height="auto" scrollable>
      <imprimir :id_comprobante="id_comprobante"></imprimir>
    </modal>
    <modal width="50%" name="auditorias" height="auto" scrollable>
      <auditorias ref="auditorias" @cancelar="cancelarAuditorias" :id_comprobante="id_comprobante"></auditorias>
    </modal>
    <modal adaptive resizable reset name="compras" height="auto" width="80%" scrollable>
      <lista-comprobantes-compra @selected="selectedCompra" :tipoComprobante="'01'"></lista-comprobantes-compra>
    </modal>
    <modal name="comprasAsignadas" scrollable width="50%" height="auto" adaptive resizable reset>
      <compras-asignadas @cerrar="$modal.hide('comprasAsignadas')" :compras="form.compras"></compras-asignadas>
    </modal>
    <modal :width="'80%'" height="auto" :scrollable="true" name="modalListaProyectos">
      <listaProyectos @selected="seleccionarProyecto"/>
    </modal>
  </div>
</template>

<script>
import ComprasAsignadas from "./ComprasAsignadas";
export default {
  components: {
    ComprasAsignadas,
  },
  props: {
    permiteClonar: {
      type: Boolean,
      required: false,
      default: false,
    },
    token: {
      type: String,
      required: false,
      default: "",
    },
    ordenTrabajo: {
      type: Object,
      required: false,
      default: function () {
        return null;
      },
    },
    clon: {
      type: Object,
      required: false,
      default: function () {
        return null;
      },
    },
    proforma: {
      type: Object,
      required: false,
      default: function () {
        return null;
      },
    },
    tipoComprobante: {
      type: String,
      required: true,
    },
    comprobante: {
      type: Object,
      required: false,
      default: null,
    },
    permiteAutorizarFactura: {
      type: Boolean,
      required: true,
    },
    permiteAutorizarNc: {
      type: Boolean,
      required: true,
    },
    permiteCrearFactura: {
      type: Boolean,
      required: true,
    },
    permiteCrearProforma: {
      type: Boolean,
      required: true,
    },
    permiteCrearNotaVenta: {
      type: Boolean,
      required: true,
    },
    permiteEditarFactura: {
      type: Boolean,
      required: true,
    },
    permiteEditarNotaVenta: {
      type: Boolean,
      required: true,
    },
    permiteAnularNotaVenta: {
      type: Boolean,
      required: true,
    },
    permiteEditarProforma: {
      type: Boolean,
      required: true,
    },
    permiteAnularFactura: {
      type: Boolean,
      required: true,
    },
    permiteAnularProforma: {
      type: Boolean,
      required: true,
    },
    permiteCrearNotaCredito: {
      type: Boolean,
      required: true,
    },
    permiteEditarNotaCredito: {
      type: Boolean,
      required: true,
    },
    permiteAnularNotaCredito: {
      type: Boolean,
      required: true,
    },
    permiteAbonarFactura: {
      type: Boolean,
      required: true,
    },
    permiteAbonarNotaVenta: {
      type: Boolean,
      required: true,
    },
    permiteEditarPrecioFactura: {
      type: Boolean,
      required: true,
    },
    permiteEditarPrecioProforma: {
      type: Boolean,
      required: true,
    },
    permiteEditarPrecioNotaVenta: {
      type: Boolean,
      required: true,
    },
    permiteEditarPrecioNotaCredito: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      datos_factura_resumida: false,
      clienteDefecto: null,
      ciudades: [],
      selectedCiudad: null,
      selectedProvincia: null,
      provincias: [],
      selectedProvEmbarque: null,
      ciudadesEmbarque: [],
      selectedCiudadEmbarque: null, 
      selectedPais: null,
      paises: [],
      provinciasDestino: [],
      selectedProvDestino: null,
      selectedPuertoDestino: null,
      tiposIncoterm: [
        'EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP',
        'DPU', 'DAP', 'DDP'
      ],
      ciudadesDestino: [],
      items: [],
      optionProyectos: [],
      selectedProyectos: [],
      selectedItem: null,
      precision: precision,
      monto_maximo_cf: 0,
      path_foto: "",
      searchItems: "",
      tipoOt: "",
      numeroOt: "",
      retencionServicios: 0,
      retencionProductos: 0,
      clonComprobante: this.clon,
      personaClosable: true,
      id_proforma: "",
      iva_incluido_exp: false,
      moduloProyecto: false,
      no_anular_consumidor_final_aut: false,
      anular_temporal: false,
      formaPagoIdDefault: '',
      rucProveedor: '',
      form: {
        incoterm_factura: '',
        prov_embarque_id: '',
        pue_embarque_id: '',
        prov_destino_id: '',
        pue_destino_id: '',
        pais_adquisicion_id: '',
        incoterm_total_si: '',
        v_flete_internacional: 0,
        v_seguro_internacional: 0,
        v_gastos_aduaneros: 0,
        v_gastos_transporte_otros: 0,
        prov_incoterm_id: '',
        lug_incoterm_id: '',
        factura_exterior: false,
        numero_documento: "",
        compras: [],
        proyectos: [],
        detalle_adicional_venta: "",
        id_orden_trabajo: "",
        selectedMotivo: null,
        id_tipo_comprobante: this.tipoComprobante,
        email: "",
        id_tipo_emision: "",
        id_cliente: "",
        fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
        id_punto_emision: "",
        motivo: "",
        formasPago: [],
        total_sin_impuestos: 0,
        descuento_total: 0,
        subtotal_no_sujeto_iva: 0,
        subtotal_exento_iva: 0,
        iva: 0,
        subtotal_iva: 0,
        subtotal_iva_0: 0,
        ice: 0,
        total: 0,
        informacionAdicional: [],
        items: [],
        total_irbpnr: 0,
        id_moneda: "",
        _method: undefined,
        numero_comprobante_afectado: "",
        tipo_comprobante_afectado: "",
        fecha_emision_comprobante_afectado: null,
        vendedor_id: "",
        fecha_autorizacion: null,
        numero_autorizacion: "",
        margen_utilidad: 0,
      },
      motivos: [
        "Factura incorrecta",
        "Error del sistema",
        "Devolución",
        "Otro",
      ],
      intento_correo: false,
      selectedVendedor: null,
      irbpnr: 0,
      url: url,
      numero_identificacion: "",
      nombre_cliente: "",
      clave_autorizacion: "",
      clave_acceso: "",
      selectedPuntoEmision: null,
      selectedTipoEmision: null,
      selectedMoneda: null,
      url: url,
      formasPago: [],
      puntosEmision: [],
      numero_comprobante: "",
      estado: "N",
      monedas: [],
      tiposEmision: [],
      anulado: "N",
      id_comprobante: "",
      codigoIva: "",
      codigoIce: "",
      codigoFactura: "",
      codigoNotaCredito: "",
      codigoProforma: "",
      codigoNotaVenta: "",
      errores: {
        id_tipo_comprobante: undefined,
        id_tipo_emision: undefined,
        id_cliente: undefined,
        fecha_emision: undefined,
        id_punto_emision: undefined,
        motivo: undefined,
        formasPago: undefined,
        total_sin_impuestos: undefined,
        descuento_total: undefined,
        subtotal_no_sujeto_iva: undefined,
        subtotal_exento_iva: undefined,
        iva: undefined,
        subtotal_iva: undefined,
        subtotal_iva_0: undefined,
        ice: undefined,
        total: undefined,
        informacionAdicional: undefined,
        items: undefined,
        total_irbpnr: undefined,
        id_moneda: undefined,
        _method: undefined,
        vendedor_id: undefined,
        email: undefined,
        selectedMotivo: undefined,
      },
      tipoComprobanteConsulta: this.tipoComprobante,
      comprobantesConsultados: [],
      ivaNoObjeto: "",
      ivaExento: "",
      ivaCero: "",
      ivaActual: "",
      vendedores: [],
      money: money,
      tiposUnidad: [],
      enColaAutorizacion: false,
      calcular_totales_final: false,
    };
  },
  computed: {
    referenciaOt: function () {
      if (this.tipoOt !== "" && this.numeroOt !== "")
        return this.tipoOt + this.numeroOt;
      return "";
    },
    margenUtilidad: function () {
      let margenUtilidad = 0;
      for (let i = 0; i < this.form.items.length; i++)
        margenUtilidad += parseFloat(this.form.items[i].margen_utilidad);
      margenUtilidad = round(margenUtilidad);
      this.form.margen_utilidad = margenUtilidad;
      return margenUtilidad;
    },
    esElectronico: function () {
      return this.selectedPuntoEmision !== null
        ? this.selectedPuntoEmision.tipo === "E"
        : false;
    },
    editable: function () {
      return (
        (this.estado === "N" ||
          this.estado === "NAT" ||
          this.estado === null ||
          this.estado === undefined) &&
        this.anulado !== "S" &&
        !this.enColaAutorizacion
      );
    },
    permiteEditarPrecio: function () {
      let permiteEditarPrecio = false;
      if (this.tipoComprobante === this.codigoFactura)
        permiteEditarPrecio = this.permiteEditarPrecioFactura;
      else if (this.tipoComprobante === this.codigoProforma)
        permiteEditarPrecio = this.permiteEditarPrecioProforma;
      else if (this.tipoComprobante === this.codigoNotaVenta)
        permiteEditarPrecio = this.permiteEditarPrecioNotaVenta;
      else if (this.tipoComprobante === this.codigoNotaCredito)
        permiteEditarPrecio = this.permiteEditarPrecioNotaCredito;
      return permiteEditarPrecio;
    },
    permiteCrearComprobante: function () {
      let permiteCrearComprobante = false;
      if (this.tipoComprobante === this.codigoFactura)
        permiteCrearComprobante = this.permiteCrearFactura;
      else if (this.tipoComprobante === this.codigoNotaCredito)
        permiteCrearComprobante = this.permiteCrearNotaCredito;
      else if (this.tipoComprobante === this.codigoProforma)
        permiteCrearComprobante = this.permiteCrearProforma;
      else if (this.tipoComprobante === this.codigoNotaVenta)
        permiteCrearComprobante = this.permiteCrearNotaVenta;
      return permiteCrearComprobante;
    },
    permiteEditarComprobante: function () {
      let permiteEditarComprobante = false;
      if (this.tipoComprobante === this.codigoFactura)
        permiteEditarComprobante = this.permiteEditarFactura;
      else if (this.tipoComprobante === this.codigoNotaCredito)
        permiteEditarComprobante = this.permiteEditarNotaCredito;
      else if (this.tipoComprobante === this.codigoProforma)
        permiteEditarComprobante = this.permiteEditarProforma;
      else if (this.tipoComprobante === this.codigoNotaVenta)
        permiteEditarComprobante = this.permiteEditarNotaVenta;
      return permiteEditarComprobante;
    },
    permiteEliminarComprobante: function () {
      let permiteEliminarComprobante = false;
      if (this.tipoComprobante === this.codigoFactura)
        permiteEliminarComprobante = this.permiteAnularFactura;
      else if (this.tipoComprobante === this.codigoNotaCredito)
        permiteEliminarComprobante = this.permiteAnularNotaCredito;
      else if (this.tipoComprobante === this.codigoProforma)
        permiteEliminarComprobante = this.permiteAnularProforma;
      else if (this.tipoComprobante === this.codigoNotaVenta)
        permiteEliminarComprobante = this.permiteAnularNotaVenta;
      return permiteEliminarComprobante;
    },
    permiteAbonarComprobante: function () {
      let permiteAbonarComprobante = false;
      if (this.tipoComprobante === this.codigoFactura)
        permiteAbonarComprobante = this.permiteAbonarFactura;
      else if (this.tipoComprobante === this.codigoNotaVenta)
        permiteAbonarComprobante = this.permiteAbonarNotaVenta;
      return permiteAbonarComprobante;
    },
  },
  methods: {
    seleccionarProyecto: function(row){
      let existeId = this.form.proyectos.some((proyecto_id) => proyecto_id == row.id);
      if(!existeId){
        this.selectedProyectos.push(row);
        this.form.proyectos.push(row.id);
      }
    },
    inputProyecto: function(){
      this.form.proyectos.splice(0, this.form.proyectos.length);
      this.selectedProyectos.forEach((proyecto) => {
        this.form.proyectos.push(proyecto.id);
      });
    },
    consultarProyectos: function(){
      this.$modal.show('modalListaProyectos');
    },
    onSearchProyecto: function(search, loading) {
      if(search.length) {
        loading(true);
        this.searchingProyecto(loading, search, this);
      }
    },
    searchingProyecto: _.debounce((loading, search, vm) => {
      fetch(`${url}/proyectos/search/${search}`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response => response.json()).then(data => {
        vm.optionProyectos = data;
        loading(false);
      });
    }, 350),
    inputPuntoEmision: function () {
      if (this.selectedPuntoEmision != null) {
        for (let i = 0; i < this.vendedores.length; i++) {
          if (this.vendedores[i].id == this.selectedPuntoEmision.usuario_id) {
            this.selectedVendedor = this.vendedores[i];
            this.form.vendedor_id = this.selectedVendedor.id;
            break;
          }
        }
      }
    },
    inputCiudad: function () {
      if (this.selectedCiudad != null) {
        this.form.lug_incoterm_id = this.selectedCiudad.id_ciudad;
      }
      else 
        this.form.lug_incoterm_id = '';
    },
    cargarCiudadesIncoterm: function () {
      axios.get(url + '/ciudades/' + this.form.prov_incoterm_id).then(({data}) => {
        this.ciudades = data;
      }).catch(() => {
        swal('Hubo un error, intente nuevamente.', 'Error', 'error');
      });
    },
    inputProvincia: function () {
      if (this.selectedProvincia != null) {
        this.form.prov_incoterm_id = this.selectedProvincia.id_provincia;
        this.cargarCiudadesIncoterm();
      }
      else 
        this.form.prov_incoterm_id = '';
    },
    cargarCiudadesEmbarque: function () {
      axios.get(url + '/ciudades/' + this.form.prov_embarque_id).then(({data}) => {
        this.ciudadesEmbarque = data;
      }).catch(() => {
        swal('Hubo un error, intente nuevamente.', 'Error', 'error');
      });
    },
    inputProvinciaEmbarque: function () {
      if (this.selectedProvEmbarque != null) {
        this.form.prov_embarque_id = this.selectedProvEmbarque.id_provincia;
        this.cargarCiudadesEmbarque();
      }
      else 
        this.form.prov_embarque_id = '';
    },
    inputCiudadEmbarque: function () {
      if (this.selectedCiudadEmbarque != null) {
        this.form.pue_embarque_id = this.selectedCiudadEmbarque.id_ciudad;
      }
      else 
        this.form.pue_embarque_id = '';
    },
    cargarProvinciasPais: function () {
      axios.get(url + '/provincias/' + this.selectedPais.id_pais).then(({data}) => {
        this.provinciasDestino = data;
      }).catch(() => {
        swal('Hubo un error, intente nuevamente.', 'Error', 'error');
      });
    },
    inputPais: function () {
      if (this.selectedPais != null) 
      {
        this.form.pais_adquisicion_id = this.selectedPais.id_pais;
        this.cargarProvinciasPais();
      }
      else 
        this.form.pais_adquisicion_id = '';
    },
    cargarCiudadesDestino: function () {
      axios.get(url + '/ciudades/' + this.form.prov_destino_id).then(({data}) => {
        this.ciudadesDestino = data;
      }).catch(() => {
        swal('Hubo un error, intente nuevamente.', 'Error', 'error');
      });
    },
    inputProvinciaDestino: function () {
      if (this.selectedProvDestino != null)
      {
        this.form.prov_destino_id = this.selectedProvDestino.id_provincia;
        this.cargarCiudadesDestino();
      }
      else 
        this.form.prov_destino_id = '';
    },
    inputPuertoDestino: function () {
      if (this.selectedPuertoDestino != null)
        this.form.pue_destino_id = this.selectedPuertoDestino.id_ciudad;
      else 
        this.form.pue_destino_id = '';
    },
    onSearchItems: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.items = json;
          loading(false);
        } else loading(false);
      };
      let urlApi = `${url}/items-search?search=${search}`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    totalInicialItem: function (item) {
      let cantidad = parseFloat(item.cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      let precio = parseFloat(item.precio);
      if (isNaN(precio)) precio = 0;
      let totalInicial = cantidad * precio;
      totalInicial = round(totalInicial);
      return totalInicial;
    },
    totalParcialItem: function (item) {
      let totalInicial = item.total_inicial;
      let totalDescuento = parseFloat(item.total_descuento);
      if (isNaN(totalDescuento)) totalDescuento = 0;
      let totalParcial = totalInicial - totalDescuento;
      totalParcial = round(totalParcial);
      return totalParcial;
    },
    ivaItem: function (item) {
      let totalParcial = item.total_parcial;
      let porcentajeIva = parseFloat(item.porcentaje_iva);
      if (isNaN(porcentajeIva)) porcentajeIva = 0;
      let iva = (porcentajeIva / 100) * totalParcial;
      iva = round(iva);
      return iva;
    },
    totalItem: function (item) {
      let total =
        parseFloat(item.total_parcial) +
        parseFloat(item.iva);
      total = round(total);
      return total;
    },
    inputItem: function () {
      if (this.selectedItem != null) {
        axios.get(url + '/items/' + this.selectedItem.sys_id).then(({ data }) => {
          let item = data;
          let detalle = {
            tipo_item: "",
            margen_utilidad: 0,
            coste: 0,
            id_item: "",
            cantidad: 1,
            precio: 0,
            precio_produccion: 0,
            total_descuento: 0,
            iva: 0,
            ice: 0,
            porcentaje_descuento: 0,
            total: 0,
            nombre_item: "",
            porcentaje_iva: 0,
            porcentaje_ice: 0,
            id_iva: "",
            id_ice: "",
            irbpnr: false,
            detalle: "",
            total_irbpnr: 0,
            detalle: "",
            total_parcial: 0,
            total_impuestos: 0,
            total_inicial: 0,
            tarifa_especifica_ice: 0,
            numero_unidades_ice: 0,
            total_parcial_ice: 0,
            porcentaje_ed_valorem: 0,
            cantidad_ice: 0,
            cantidad_irbpnr: 0,
            mostrar_detalle: true,
            iva_incluido_precio: false
          };
          detalle.id_item = item.codigo;
          detalle.nombre_item = item.nombre;
          detalle.valor_subsidio = item.valor_subsidio;
          detalle.precio_sin_subsidio = item.precio_sin_subsidio;
          detalle.iva_incluido_precio = item.iva_incluido_precio === "S";
          if (this.tipoComprobante === "99") {
            if (!detalle.iva_incluido_precio)
              detalle.precio = round(
                parseFloat(item.precio_subsidiado) *
                (1 + parseFloat(item.tarifa_iva.porcentaje) / 100)
              );
            else detalle.precio = parseFloat(item.precio_subsidiado);
            detalle.id_iva = "6";
            detalle.id_ice = null;
            detalle.irbpnr = false;
            detalle.porcentaje_iva = 0;
          } else {
            let porcentaje = parseFloat(item.tarifa_iva.porcentaje);
            if (isNaN(porcentaje)) porcentaje = 0;
            if (porcentaje > 0 && (detalle.iva_incluido_precio || (detalle.iva_incluido_precio && !this.iva_incluido_exp && this.form.factura_exterior))) {
              let precio = parseFloat(item.precio_subsidiado);
              if (isNaN(precio)) precio = 0;
              detalle.precio = round(precio / (1 + porcentaje / 100));
            } else {
              detalle.precio = item.precio_subsidiado;
            }
            if (this.form.factura_exterior) {
              item.id_iva = '0';
            }
            else {
              detalle.id_iva = item.id_tarifa_iva;
            }
            detalle.id_ice = item.id_tarifa_ice;
            if (this.form.factura_exterior) { 
              detalle.porcentaje_iva = 0;
            }
            else 
              detalle.porcentaje_iva = item.tarifa_iva.porcentaje;
            if (item.tarifa_ice !== null) {
              detalle.porcentaje_ice = item.tarifa_ice.porcentaje;
              detalle.tarifa_especifica_ice =
                item.tarifa_ice.tarifa_especifica;
              detalle.numero_unidades_ice = item.tarifa_ice.numero_unidades;
              detalle.porcentaje_ed_valorem =
                item.tarifa_ice.porcentaje_ed_valorem;
              detalle.cantidad_ice = item.cantidad_ice;
            }
            detalle.precio_produccion = item.precio_produccion;
            detalle.cantidad_irbpnr = item.cantidad_irbpnr;
            if (detalle.cantidad_irbpnr === null)
              detalle.cantidad_irbpnr = 1;
            detalle.irbpnr = item.irbpnr === "S";
          }
          detalle.coste = item.costo;
          let cantidad = 1;
          let indexEncontrado = -1;
          for (let i = 0; i < this.form.items.length; i++) {
            if (this.form.items[i].id_item == item.codigo) {
              cantidad = parseFloat(this.form.items[i].cantidad) + 1;
              indexEncontrado = i;
              break;
            }
          }
          detalle.cantidad = cantidad;
          detalle.total_inicial = this.totalInicialItem(detalle);
          detalle.total_parcial = this.totalParcialItem(detalle);
          detalle.iva = this.ivaItem(detalle);
          detalle.total = this.totalItem(detalle);
          if (indexEncontrado > -1)
            this.form.items.splice(indexEncontrado, 1, detalle);
          else
            this.form.items.push(detalle);
          this.calcularTotales();
          this.selectedItem = null;
        }).catch(() => {
          swal('Hubo un error, intente nuevamente.', 'Error', 'error');
        });
      }
    },
    cargarNumeroActual: function () {
      if (
        this.selectedPuntoEmision != null &&
        !this.esElectronico &&
        this.selectedPuntoEmision.precargar_numero === "S"
      ) {
        axios
          .get(url + "/" + this.selectedPuntoEmision.id + "/numero-actual")
          .then(({ data }) => {
            this.form.numero_documento = data.numero_actual;
          });
      }
    },
    notificarDeuda: function () {
      swal({
        title: "¿Desea enviar la notificación de deuda?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Enviar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/notificar-deudas/" + this.id_comprobante)
            .then(() => {
              swal(
                "El comprobante ha sido puesto en cola de notificaciones.",
                "Aviso",
                "warning"
              );
            })
            .catch(({ response }) => {
              if (response.status === 404) {
                swal(
                  "El comprobante no tiene saldo disponible por notificar.",
                  "Aviso",
                  "warning"
                );
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    consultarCompras: function () {
      this.$modal.show("compras");
    },
    compraExiste: function (id) {
      for (let i = 0; i < this.form.compras.length; i++) {
        if (this.form.compras[i].id == id) {
          return true;
        }
      }
      return false;
    },
    selectedCompra: function (compra) {
      if (!this.compraExiste(compra.id_comprobante)) {
        this.form.compras.push({
          id: compra.id_comprobante,
          numero: compra.numero + " ( " + compra.nombre_comercial + ")",
        });
        this.$modal.hide("compras");
      } else {
        swal("La compra seleccionada ya ha sido agregada.", "Aviso", "warning");
      }
    },
    descargarArchivo: function () {
      window.open(this.path_foto, "_blank");
    },
    submitFoto: function (event) {
      if (document.getElementById("path_foto").files.length === 0) {
        event.preventDefault();
        swal("Debe seleccionar un documento.", "Aviso", "warning");
      }
    },
    calcularUtilidad: function () {
      let margenUtilidad = 0;
      for (let i = 0; i < this.form.items.length; i++)
        margenUtilidad += parseFloat(this.form.items[i].margen_utilidad);
      margenUtilidad = round(margenUtilidad);
      this.form.margen_utilidad = margenUtilidad;
    },
    verOt: function () {
      window.open(
        url + "/orden-trabajo/" + this.form.id_orden_trabajo + "/edit",
        "_blank"
      );
    },
    inputFormasPago: function () {
      this.actualizarFechaVencimiento();
    },
    actualizarFechaVencimiento: function () {
      if (this.form.fecha_emision.length === 10) {
        let fecha = new Date(this.form.fecha_emision + " 00:00:00");
        if (fecha != "Invalid Date") {
          for (let i = 0; i < this.form.informacionAdicional.length; i++) {
            if (
              this.form.informacionAdicional[i].nombre_campo ===
              "Fecha de vencimiento"
            ) {
              let dias = 0;
              for (let j = 0; j < this.form.formasPago.length; j++) {
                let unidadDias = 0;
                if (this.form.formasPago[j].unidad_tiempo === "días")
                  unidadDias = 1;
                else if (this.form.formasPago[j].unidad_tiempo === "meses")
                  unidadDias = 30;
                else if (this.form.formasPago[j].unidad_tiempo === "años")
                  unidadDias = 365;
                else if (this.form.formasPago[j].unidad_tiempo === "semanas")
                  unidadDias = 7;
                let diasPago = parseInt(this.form.formasPago[j].plazo);
                if (isNaN(diasPago)) diasPago = 0;
                if (diasPago > 0) diasPago = diasPago * unidadDias;
                let fechaVencimiento = moment(fecha).add(diasPago, "days");
                this.form.informacionAdicional[
                  i
                ].valor_campo = fechaVencimiento.format("YYYY-MM-DD");
              }
              break;
            }
          }
        }
      }
    },
    ponerFechaVencimiento: function () {
      this.form.informacionAdicional.push({
        enviar_sri: true,
        nombre_campo: "Fecha de vencimiento",
        valor_campo: "",
      });
    },
    clonar: function () {
      window.open(
        this.url + "/comprobantes/" + this.id_comprobante + "/clonar",
        "_blank"
      );
    },
    enviarComprobantesAnulados: function () {
      let that = this;
      swal({
        title: "¿Desea enviar el comprobante anulado?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Enviar",
        cancelButtonText: "No",
      }).then(function (result) {
        if (result.value) {
          axios
            .post(
              that.url +
              "/comprobantes/" +
              that.id_comprobante +
              "/correos-anulados"
            )
            .then(function (response) {
              if (response.data.enviado)
                swal(
                  "El comprobante ha sido enviado por correo electrónico.",
                  "Aviso",
                  "success"
                );
              else
                swal(
                  "No se ha otorgado direcciones electrónicas que puedan recibir el comprobante electrónico.",
                  "Aviso",
                  "success"
                );
            })
            .catch(function (error) {
              swal(
                "Hubo un error al intentar enviar el comprobante.",
                "Aviso",
                "warning"
              );
            });
        }
      });
    },
    verAnterior: function () {
      let numeroDocumento = this.numero_comprobante;
      if (this.numero_comprobante != null && this.numero_comprobante != "")
        numeroDocumento = numeroDocumento.replace("-", "").replace("-", "");
      else numeroDocumento = "9".padStart(15, "9");
      let that = this;
      axios
        .get(
          url +
          "/comprobantes/" +
          this.tipoComprobante +
          "/" +
          numeroDocumento +
          "/N/cargar"
        )
        .then(function (response) {
          if (response.data.id_comprobante != null)
            location.href =
              url +
              "/comprobantes?tipo_comprobante=" +
              that.tipoComprobante +
              "&id_comprobante=" +
              response.data.id_comprobante;
          else swal("No se encontró otro comprobante.", "Aviso", "warning");
        });
    },
    verSiguiente: function () {
      let numeroDocumento = this.numero_comprobante;
      if (this.numero_comprobante != null && this.numero_comprobante != "")
        numeroDocumento = numeroDocumento.replace("-", "").replace("-", "");
      else numeroDocumento = "9".padStart(15, "9");
      let that = this;
      axios
        .get(
          url +
          "/comprobantes/" +
          this.tipoComprobante +
          "/" +
          numeroDocumento +
          "/S/cargar"
        )
        .then(function (response) {
          if (response.data.id_comprobante != null)
            location.href =
              url +
              "/comprobantes?tipo_comprobante=" +
              that.tipoComprobante +
              "&id_comprobante=" +
              response.data.id_comprobante;
          else swal("No se encontró otro comprobante.", "Aviso", "warning");
        });
    },
    generarGuia: function () {
      window.open(
        this.url + "/comprobantes/" + this.id_comprobante + "/generar-guia",
        "_blank"
      );
    },
    autorizar: function () {
      let that = this;
      swal({
        title: "¿Desea autorizar este comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Autorizar comprobante",
        cancelButtonText: "No",
      }).then(function (result) {
        if (result.value) {
          axios
            .post(that.url + "/autorizacion-documentos", {
              comprobantes: [that.id_comprobante],
            })
            .then(function (response) {
              swal(
                "El comprobante ha sido enviado a autorizar.",
                "Aviso",
                "success"
              );
              that.enColaAutorizacion = true;
              that.anular_temporal = true;
            })
            .catch(function (error) {
              swal(
                "Hubo un error al intentar autorizar el documento, intente nuevamente.",
                "Aviso",
                "warning"
              );
            });
        }
      });
    },
    cancelarAuditorias: function () {
      this.$modal.hide("auditorias");
    },
    mostrarAuditorias: function () {
      this.$modal.show("auditorias");
    },
    abrirLogs: function () {
      window.open(
        this.url + "/comprobantes/" + this.id_comprobante + "/logs",
        "_blank"
      );
    },
    enviarCorreo: function () {
      let that = this;
      axios
        .post(this.url + "/comprobantes/" + this.id_comprobante + "/correo")
        .then(function (response) {
          let comprobantesAfectados = response.data.comprobantesAfectados;
          if (comprobantesAfectados > 0)
            swal(
              "El comprobante ha sido enviado a la cola de envío de correos electrónicos.",
              "Aviso",
              "success"
            );
          else
            swal("No se ha enviado el correo electrónico.", "Aviso", "warning");
        });
    },
    consultarComprobantesVenta: function () {
      this.tipoComprobanteConsulta =
        this.tipoComprobante === this.codigoFactura
          ? this.codigoProforma
          : this.codigoFactura;
      this.$modal.show("listaComprobantes");
    },
    seleccionarComprobanteAfectado: function (comprobante) {
      this.tipoComprobanteConsulta =
        this.tipoComprobante === this.codigoFactura
          ? this.codigoProforma
          : this.codigoFactura;
      this.selectedComprobante(comprobante);
      this.ponerDetalleAdicional();
      this.$modal.hide("coincidenciaComprobantes");
    },
    quitarComprobanteAfectado: function () {
      this.form.numero_comprobante_afectado = "";
      this.form.tipo_comprobante_afectado = "";
      this.form.fecha_emision_comprobante_afectado = null;
      this.form.id_cliente = "";
      this.nombre_cliente = "";
      this.numero_identificacion = "";
      this.form.items = [];
    },
    consultarComprobanteAfectado: function () {
      if (this.form.numero_comprobante_afectado !== "") {
        let that = this;
        axios
          .get(
            this.url + "/comprobantes/" + this.form.numero_comprobante_afectado,
            {
              params: {
                tipoComprobanteAfectado:
                  this.tipoComprobante === this.codigoFactura
                    ? this.codigoProforma
                    : this.codigoFactura,
              },
            }
          )
          .then(function (response) {
            if (response.data.length > 0) {
              if (response.data.length === 1) {
                that.tipoComprobanteConsulta =
                  that.tipoComprobante === that.codigoFactura
                    ? that.codigoProforma
                    : that.codigoFactura;
                that.selectedComprobante(response.data[0]);
              } else {
                that.comprobantesConsultados = response.data;
                that.$modal.show("coincidenciaComprobantes");
              }
            } else {
              that.quitarComprobanteAfectado();
              swal(
                "No se encontró comprobantes con el número proporcionado.",
                "Mensaje",
                "warning"
              );
            }
          });
      } else
        swal("Debe ingresar un número de comprobante.", "Aviso", "warning");
    },
    buscarComprobanteAfectado: function () {
      this.tipoComprobanteConsulta =
        this.tipoComprobante === this.codigoFactura
          ? this.codigoProforma
          : this.codigoFactura;
      this.$modal.show("listaComprobantes");
    },
    consultarPersonas: function () {
      this.$modal.show("listaPersonas");
    },
    obtenerInformacionAdicional: function (nombre) {
      for (let i = 0; i < this.form.informacionAdicional.length; i++)
        if (this.form.informacionAdicional[i].nombre_campo === nombre)
          return this.form.informacionAdicional[i];
      return null;
    },
    selectedPersona: function (persona) {
      this.$modal.hide("listaPersonas");
      this.numero_identificacion = persona.identificacion;
      this.form.id_cliente = persona.id;
      this.form.email = persona.email;
      this.nombre_cliente = persona.nombre;
      let informacionEmail = this.obtenerInformacionAdicional("Email");
      if (informacionEmail === null)
        this.form.informacionAdicional.push({
          nombre_campo: "Email",
          valor_campo: persona.email,
          enviar_sri: true,
        });
      else informacionEmail.valor_campo = persona.email;
      let informacionTelefono = this.obtenerInformacionAdicional("Teléfono");
      if (persona.telefono !== null) {
        if (informacionTelefono === null)
          this.form.informacionAdicional.push({
            nombre_campo: "Teléfono",
            valor_campo: persona.telefono,
            enviar_sri: true,
          });
        else informacionTelefono.valor_campo = persona.telefono;
      } else if (informacionTelefono !== null)
        this.form.informacionAdicional.splice(
          this.form.informacionAdicional.indexOf(informacionTelefono),
          1
        );
    },
    imprimirPDF: function () {
      window.open(
          this.url + "/comprobantes/" + this.id_comprobante + "/ride",
          "_blank"
        );
    },
    imprimirComprobante: function () {
      if (this.selectedPuntoEmision != null && this.selectedPuntoEmision.punto_venta === "S")
        window.open(
          this.url + "/comprobantes/" + this.id_comprobante + "/ride?tipo_impresion=PV",
          "_blank"
        );
      else
        window.open(
          this.url + "/comprobantes/" + this.id_comprobante + "/ride",
          "_blank"
        );
    },
    anularComprobante: function () {
      if(this.anular_temporal || (this.no_anular_consumidor_final_aut && this.estado == 'AUT' && this.numero_identificacion == '9999999999999'))
        return;
      let that = this;
      swal({
        title: "¿Desea anular este comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Anular comprobante",
        cancelButtonText: "No",
      }).then(function (result) {
        if (result.value) {
          axios
            .post(
              that.url + "/comprobantes/" + that.id_comprobante + "/anular",
              {
                _method: "DELETE",
              }
            )
            .then(function (response) {
              that.anulado = "S";
              if (response.data.error_correos)
                swal(
                  "El comprobante ha sido anulado pero no pudo enviarse por correo electrónico.",
                  "Anulado",
                  "warning"
                );
              else
                swal("El comprobante ha sido anulado.", "Anulado", "success");
            });
        }
      });
    },
    nuevoComprobante: function () {
      swal({
        title: "¿Desear crear un nuevo comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Nuevo comprobante",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.path_foto = "";
          this.tipoOt = "";
          this.numeroOt = "";
          this.enColaAutorizacion = false;
          this.personaClosable = true;
          this.id_proforma = "";
          this.form = {
            numero_documento: "",
            id_orden_trabajo: "",
            id_tipo_comprobante: this.tipoComprobante,
            id_tipo_emision: "",
            id_cliente: "",
            fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
            id_punto_emision: "",
            motivo: "",
            formasPago: [],
            total_sin_impuestos: 0,
            descuento_total: 0,
            subtotal_no_sujeto_iva: 0,
            subtotal_exento_iva: 0,
            iva: 0,
            subtotal_iva: 0,
            subtotal_iva_0: 0,
            ice: 0,
            total: 0,
            informacionAdicional: [],
            items: [],
            total_irbpnr: 0,
            id_moneda: "",
            vendedor_id: "",
            email: "",
            selectedMotivo: null,
            motivo: "",
            numero_comprobante_afectado: "",
            tipo_comprobante_afectado: "",
            fecha_emision_comprobante_afectado: null,
            vendedor_id: "",
            compras: [],
            proyectos: [],
            incoterm_factura: '',
            prov_embarque_id: '',
            pue_embarque_id: '',
            prov_destino_id: '',
            pue_destino_id: '',
            pais_adquisicion_id: '',
            incoterm_total_si: '',
            v_flete_internacional: 0,
            v_seguro_internacional: 0,
            v_gastos_aduaneros: 0,
            v_gastos_transporte_otros: 0,
            prov_incoterm_id: '',
            lug_incoterm_id: '',
            factura_exterior: false
          };
          this.selectedProvincia = null;
          this.selectedCiudad = null;
          this.selectedProvDestino = null;
          this.selectedPuertoDestino = null;
          this.selectedProvEmbarque = null;
          this.selectedCiudadEmbarque = null;
          this.selectedPais = null;
          this.selectedProyectos.splice(0, this.selectedProyectos.length);
          this.intento_correo = false;
          this.errores = {};
          this.numero_comprobante = "";
          this.numero_identificacion = "";
          this.nombre_cliente = "";
          this.estado = "N";
          this.anulado = "N";
          this.id_comprobante = "";
          this.form.fecha_autorizacion = null;
          this.form.numero_autorizacion = "";
          this.clave_acceso = "";
          this.selectedVendedor = null;
          this.selectedPuntoEmision = null;
          this.selectedTipoEmision = null;
          this.selectedMoneda = null;
          if (this.vendedores.length > 0)
            this.selectedVendedor = this.vendedores[0];
          if (this.puntosEmision.length > 0)
          {
            this.selectedPuntoEmision = this.puntosEmision[0];
            this.inputPuntoEmision();
          }
          if (this.monedas.length > 0) this.selectedMoneda = this.monedas[0];
          if (this.tiposEmision.length > 0)
            this.selectedTipoEmision = this.tiposEmision[0];
          this.ponerDetalleAdicional();
          if (this.tipoComprobante === this.codigoFactura && this.clienteDefecto != null)
            this.selectedPersona(this.clienteDefecto);
        }
      });
    },
    savedPersona: function (persona) {
      this.selectedPersona(persona);
      this.$modal.hide("persona");
    },
    consultarCliente: function () {
      if (this.numero_identificacion !== "") {
        let that = this;
        axios
          .get(this.url + "/personas/" + this.numero_identificacion, {
            params: {
              tipoFiltro: "C",
            },
          })
          .then(function (response) {
            that.selectedPersona(response.data);
          })
          .catch(function (error) {
            if (error !== undefined && error !== null) {
              let response = error.response;
              if (response !== undefined && response !== null) {
                let status = response.status;
                if (status === 404) {
                  swal({
                    title: "¿Desear crear una nueva persona?",
                    text: "Esta acción requiere de confirmación.",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: "Nueva persona",
                    cancelButtonText: "No",
                  }).then((result) => {
                    if (result.value) {
                      that.personaClosable = true;
                      that.nombre_cliente = "";
                      that.form.email = "";
                      that.form.id_cliente = "";
                      that.crearNuevaPersona();
                    }
                  });
                } else
                  swal(
                    "Hubo un error al momento de consultar el número. Intente nuevamente.",
                    "Error",
                    "error"
                  );
              }
            }
          });
      } else
        swal("Debe ingresar un número de identificación.", "Aviso", "warning");
    },
    abrirAbonos: function () {
      this.$modal.show("listaAbonos");
    },
    quitarCliente: function () {
      this.nombre_cliente = "";
      this.form.id_cliente = "";
      this.form.email = "";
      let informacionEmail = this.obtenerInformacionAdicional("Email");
      if (informacionEmail !== null)
        this.form.informacionAdicional.splice(
          this.form.informacionAdicional.indexOf(informacionEmail),
          1
        );
      let informacionTelefono = this.obtenerInformacionAdicional("Teléfono");
      if (informacionTelefono !== null)
        this.form.informacionAdicional.splice(
          this.form.informacionAdicional.indexOf(informacionTelefono),
          1
        );
    },
    crearNuevaPersona: function () {
      this.$modal.show("persona");
    },
    cargarDatosFormulario: function () {
      let that = this;
      axios
        .get(this.url + "/comprobantes/" + this.tipoComprobante + "/datos")
        .then(function (response) {
          that.datos_factura_resumida = response.data.datos_factura_resumida;
          that.clienteDefecto = response.data.clienteDefecto;
          that.iva_incluido_exp = response.data.iva_incluido_exp;
          that.paises = response.data.paises;
          that.provincias = response.data.provincias;
          that.calcular_totales_final = response.data.calcular_totales_final;
          that.monto_maximo_cf = response.data.monto_maximo_cf;
          that.formasPago = response.data.formasPago;
          that.formaPagoIdDefault = response.data.formaPagoIdDefault;
          that.puntosEmision = response.data.puntosEmision;
          that.vendedores = response.data.vendedores;
          if (that.puntosEmision.length > 0)
          {
            that.selectedPuntoEmision = that.puntosEmision[0];
            that.inputPuntoEmision();
          }
          that.irbpnr = parseFloat(response.data.irbpnr.valor_tarifa);
          that.monedas = response.data.monedas;
          if (that.monedas.length > 0) that.selectedMoneda = that.monedas[0];
          that.tiposEmision = response.data.tiposEmision;
          if (that.tiposEmision.length > 0)
            that.selectedTipoEmision = that.tiposEmision[0];
          that.codigoIva = response.data.codigoIva;
          that.codigoIce = response.data.codigoIce;
          that.codigoFactura = response.data.codigoFactura;
          that.codigoProforma = response.data.codigoProforma;
          that.codigoNotaVenta = response.data.codigoNotaVenta;
          that.codigoNotaCredito = response.data.codigoNotaCredito;
          that.ivaNoObjeto = response.data.ivaNoObjeto;
          that.ivaExento = response.data.ivaExento;
          that.ivaCero = response.data.ivaCero;
          that.ivaActual = response.data.ivaActual;
          that.detalle_adicional_venta = response.data.detalle_adicional_venta;
          that.rucProveedor = response.data.rucProveedor;
          that.retencionServicios = parseFloat(
            response.data.retencion_servicios
          );
          that.retencionProductos = parseFloat(
            response.data.retencion_productos
          );
          if (that.selectedVendedor == null && that.vendedores.length > 0)
            that.selectedVendedor = that.vendedores[0];
          that.tiposUnidad = response.data.tiposUnidad;
          if (that.comprobante !== null)
            that.selectedComprobante(that.comprobante);
          else if (that.proforma !== null)
            that.seleccionarComprobanteAfectado(that.proforma);
          else if (that.clonComprobante !== null)
            that.selectedComprobante(that.clonComprobante);
          else if (that.ordenTrabajo !== null)
            that.cargarOrdenTrabajo(that.ordenTrabajo);
          if (that.comprobante === null && that.clon === null) {
            that.ponerFechaVencimiento();
            that.actualizarFechaVencimiento();
            that.ponerDetalleAdicional();
            if (that.tipoComprobante === that.codigoFactura && that.clienteDefecto != null)
              that.selectedPersona(that.clienteDefecto);
          }
          that.moduloProyecto = response.data.moduloProyecto;
          that.no_anular_consumidor_final_aut = response.data.no_anular_consumidor_final_aut == 'S';
        });
    },
    ponerDetalleAdicional: function () {
      if (
        this.detalle_adicional_venta != null &&
        this.detalle_adicional_venta !== ""
      ) {
        let existeDetalle = false;
        for (let i = 0; i < this.form.informacionAdicional.length; i++) {
          if (
            this.form.informacionAdicional[i].nombre_campo ==
            "Detalle adicional"
          ) {
            existeDetalle = true;
            break;
          }
        }
        if (!existeDetalle)
          this.form.informacionAdicional.push({
            enviar_sri: true,
            nombre_campo: "Detalle adicional",
            valor_campo: this.detalle_adicional_venta,
          });
      }
      if (this.rucProveedor != null && this.rucProveedor != '') {
        const existeRucProveedor = this.form.informacionAdicional.some(
          (item) => item.nombre_campo === "RUC Proveedor"
        );
        if (!existeRucProveedor) {
          this.form.informacionAdicional.push({
            enviar_sri: true,
            nombre_campo: "RUC Proveedor",
            valor_campo: this.rucProveedor,
          });
        }
      }
    },
    cargarOrdenTrabajo: function (ot) {
      this.form.id_orden_trabajo = ot.id;
      this.tipoOt = ot.tipo_documento;
      this.numeroOt = ot.numero_documento;
      if (ot.cliente !== null) {
        this.form.id_cliente = ot.persona_id;
        this.form.email = ot.cliente.email;
        this.numero_identificacion = ot.cliente.identificacion;
        this.personaClosable = true;
      } else {
        this.personaClosable = false;
        this.$modal.show("persona");
        swal("Debe registrar a la persona para continuar.", "Aviso", "warning");
      }
      for (let i = 0; i < this.vendedores.length; i++)
        if (this.vendedores[i].id == ot.vendedor_id) {
          this.selectedVendedor = this.vendedores[i];
          break;
        }
      this.nombre_cliente = ot.nombre_persona;
      if (ot.comentario !== null) {
        this.form.informacionAdicional.push({
          nombre_campo: "Comentario",
          valor_campo: ot.comentario,
          enviar_sri: false,
        });
      }
      for (let i = 0; i < ot.detalles.length; i++) {
        let precioTotal =
          parseFloat(ot.detalles[i].cantidad) *
          parseFloat(ot.detalles[i].item.precio_unitario);
        let item = {
          cantidad: ot.detalles[i].cantidad,
          precio: ot.detalles[i].item.precio_unitario,
          nombre_item: ot.detalles[i].item.descripcion,
          total_descuento: 0,
          total_parcial: precioTotal,
          id_item: ot.detalles[i].item.id_item,
          total_impuestos: 0,
          total: precioTotal,
          precio_produccion: 0,
          irbpnr: false,
          total_irbpnr: 0,
          cantidad_ice: 0,
          cantidad_irbpnr: 0,
          ice: 0,
          id_ice: "",
          detalle: "",
          valor_subsidio: ot.detalles[i].item.valor_subsidio,
          precio_sin_subsidio: ot.detalles[i].item.precio_sin_subsidio,
          mostrar_detalle: true,
          porcentaje_ice: 0,
          numero_unidades_ice: 0,
          tarifa_especifica_ice: 0,
          porcentaje_ed_valorem: 0,
        };
        for (let j = 0; j < ot.detalles[i].item.impuestos.length; j++) {
          if (ot.detalles[i].item.impuestos[j].id_impuesto === this.codigoIva) {
            item.id_iva = ot.detalles[i].item.impuestos[j].id_tarifa;
            let nuevoValor = round(
              precioTotal *
              (parseFloat(ot.detalles[i].item.impuestos[j].porcentaje) / 100)
            );
            item.iva = nuevoValor;
            item.porcentaje_iva = ot.detalles[i].item.impuestos[j].porcentaje;
          }
          let iva = parseFloat(item.iva);
          item.total_impuestos += isNaN(iva) ? 0 : iva;
        }
        item.total += parseFloat(item.total_impuestos);
        this.form.items.push(item);
        this.calcularTotales();
      }
    },
    inputDetalles: function (detalles) {
      this.form.items = detalles;
      this.calcularUtilidad();
      this.calcularTotales();
    },
    consultarComprobantes: function () {
      this.tipoComprobanteConsulta = this.tipoComprobante;
      this.$modal.show("listaComprobantes");
    },
    selectedComprobante: function (comprobante) {
      if (this.tipoComprobanteConsulta !== this.tipoComprobante)
        if (comprobante.anulado === "S") {
          swal("El comprobante ha sido anulado.", "No permitido", "warning");
          return;
        }
      this.nombre_cliente = comprobante.nombre_cliente;
      this.form.email = comprobante.correo_cliente;
      this.numero_identificacion = comprobante.numero_identificacion;
      if (comprobante.cliente !== null) {
        this.form.id_cliente = comprobante.cliente.id;
        this.personaClosable = true;
      } else {
        this.id_proforma = comprobante.id_comprobante;
        this.personaClosable = false;
        this.$modal.show("persona");
        swal("Debe registrar a la persona para continuar.", "Aviso", "warning");
      }
      this.form.subtotal_exento_iva = comprobante.subtotal_exento_iva;
      this.form.subtotal_iva = comprobante.subtotal_iva;
      this.form.subtotal_iva_0 = comprobante.subtotal_iva_0;
      this.form.subtotal_no_sujeto_iva = comprobante.subtotal_no_iva;
      this.form.descuento_total = comprobante.total_descuento;
      this.form.total_sin_impuestos = comprobante.total_sin_impuestos;
      this.form.ice = comprobante.valor_ice;
      this.form.iva = comprobante.valor_iva;
      this.form.total_irbpnr = comprobante.valor_irbpnr;
      this.form.total = comprobante.valor_total;
      this.form.items = [];
      this.selectedMoneda = null;
      this.selectedVendedor = null;
      this.selectedTipoEmision = null;
      for (let i = 0; i < this.monedas.length; i++)
        if (this.monedas[i].id_moneda === comprobante.id_moneda) {
          this.selectedMoneda = this.monedas[i];
          break;
        }
      if (this.selectedMoneda === null && this.monedas.length > 0)
        this.selectedMoneda = this.monedas[0];
      for (let i = 0; i < this.tiposEmision.length; i++)
        if (
          this.tiposEmision[i].id_tipo_emision === comprobante.id_tipo_emision
        ) {
          this.selectedTipoEmision = this.tiposEmision[i];
          break;
        }
      if (this.tipoComprobanteConsulta === this.tipoComprobante) {
        this.form.incoterm_factura = comprobante.incoterm_factura;
        this.form.prov_embarque_id = comprobante.prov_embarque_id;
        this.form.pue_embarque_id = comprobante.pue_embarque_id;
        this.form.prov_destino_id = comprobante.prov_destino_id;
        this.form.pue_destino_id = comprobante.pue_destino_id;
        this.form.pais_adquisicion_id = comprobante.pais_adquisicion_id;
        this.form.incoterm_total_si = comprobante.incoterm_total_si;
        this.form.v_flete_internacional = comprobante.v_flete_internacional;
        this.form.v_seguro_internacional = comprobante.v_seguro_internacional;
        this.form.v_gastos_aduaneros = comprobante.v_gastos_aduaneros;
        this.form.v_gastos_transporte_otros = comprobante.v_gastos_transporte_otros;
        this.form.prov_incoterm_id = comprobante.prov_incoterm_id;
        this.form.lug_incoterm_id = comprobante.lug_incoterm_id;
        this.selectedProvincia = comprobante.provincia_incoterm;
        this.selectedCiudad = comprobante.lugar_incoterm;
        this.selectedProvDestino = comprobante.provincia_destino;
        this.selectedPuertoDestino = comprobante.puerto_destino;
        this.selectedProvEmbarque = comprobante.provincia_embarque;
        this.selectedCiudadEmbarque = comprobante.puerto_embarque;
        this.selectedPais = comprobante.pais_adquisicion;
        this.form.id_orden_trabajo = comprobante.id_orden_trabajo;
        this.form.factura_exterior = comprobante.factura_exterior === 'S';
        if (comprobante.orden_trabajo_fac != null) {
          this.tipoOt = comprobante.orden_trabajo_fac.tipo_documento;
          this.numeroOt = comprobante.orden_trabajo_fac.numero_documento;
        }
        if (this.clonComprobante === null)
          this.enColaAutorizacion =
            comprobante.pendiente_envio === "S" &&
            !comprobante.id_estado_comprobante === "NAT";
        else this.enColaAutorizacion = false;
        this.selectedPuntoEmision = null;
        let regExp = /\(([^)]+)\)/;
        let matches = regExp.exec(comprobante.motivo);
        if (matches !== null) this.form.motivo = matches[1];
        this.form.selectedMotivo =
          comprobante.motivo !== null
            ? comprobante.motivo.split("(")[0].trim()
            : null;
        this.form.numero_comprobante_afectado =
          comprobante.numeracion_comp_venta;
        this.form.tipo_comprobante_afectado = comprobante.id_tipo_comp_venta;
        if (comprobante.fecha_emision_comp_venta !== null)
          this.form.fecha_emision_comprobante_afectado = moment(
            new Date(comprobante.fecha_emision_comp_venta)
          ).format("YYYY-MM-DD");
        else this.form.fecha_emision_comprobante_afectado = "";
        if (this.clonComprobante === null) {
          this.anulado = comprobante.anulado;
          this.numero_comprobante =
            comprobante.codigo_establecimiento +
            "-" +
            comprobante.codigo_emisor +
            "-" +
            comprobante.numero_secuencial;
          this.id_comprobante = comprobante.id_comprobante;
          this.form.fecha_emision = moment(
            new Date(comprobante.fecha_emision)
          ).format("YYYY-MM-DD");
          this.clave_acceso = comprobante.clave_acceso;
        }
        if (
          comprobante.id_tipo_comprobante !== this.codigoProforma &&
          this.clonComprobante === null
        )
          this.estado = comprobante.id_estado_comprobante;
        else this.estado = "N";
        for (let i = 0; i < this.puntosEmision.length; i++) {
          if (
            this.puntosEmision[i].numero_secuencia ===
            comprobante.codigo_emisor &&
            this.puntosEmision[i].localidad.numero_localidad ===
            comprobante.codigo_establecimiento
          ) {
            this.selectedPuntoEmision = this.puntosEmision[i];
            break;
          }
        }
        if (comprobante.fecha_autorizacion !== null) {
          if (
            this.selectedPuntoEmision !== null &&
            this.selectedPuntoEmision.tipo === "E"
          )
            this.form.fecha_autorizacion = moment(
              new Date(comprobante.fecha_autorizacion)
            ).format("YYYY-MM-DD HH:mm");
          else
            this.form.fecha_autorizacion = moment(
              new Date(comprobante.fecha_autorizacion)
            ).format("YYYY-MM-DD");
        } else this.form.fecha_autorizacion = null;
        this.form.numero_autorizacion = comprobante.numero_autorizacion;
        for (let i = 0; i < this.vendedores.length; i++)
          if (this.vendedores[i].id == comprobante.vendedor_id) {
            this.selectedVendedor = this.vendedores[i];
            break;
          }
        this.form.formasPago = [];
        for (let i = 0; i < comprobante.formas_pago.length; i++)
          this.form.formasPago.push({
            plazo: comprobante.formas_pago[i].plazo,
            unidad_tiempo: comprobante.formas_pago[i].unidad_tiempo,
            valor: comprobante.formas_pago[i].total,
            selectedFormaPago: comprobante.formas_pago[i].forma_pago,
          });
        this.intento_correo = comprobante.intento_correo;
        this.form.guia_remision = comprobante.numero_guia_remision;
        if (comprobante.path_foto != null)
          this.path_foto = url + "/storage/" + comprobante.path_foto;
        else this.path_foto = "";
        if (comprobante.compras != null) {
          this.form.compras.splice(0, this.form.compras.length);
          for (let i = 0; i < comprobante.compras.length; i++) {
            this.form.compras.push({
              id: comprobante.compras[i].id,
              numero: comprobante.compras[i].numero,
            });
          }
        }
        if(comprobante.proyectos != null) {
          this.selectedProyectos.splice(0, this.selectedProyectos.length);
          comprobante.proyectos.forEach((proyecto) => {
            this.selectedProyectos.push(proyecto);
            this.form.proyectos.push(proyecto.id);
          });
        }
      } else {
        this.form.numero_comprobante_afectado =
          comprobante.codigo_establecimiento +
          "-" +
          comprobante.codigo_emisor +
          "-" +
          comprobante.numero_secuencial;
        this.form.tipo_comprobante_afectado = comprobante.id_tipo_comprobante;
        this.form.fecha_emision_comprobante_afectado = moment(
          new Date(comprobante.fecha_emision)
        ).format("YYYY-MM-DD");
        for (let i = 0; i < this.vendedores.length; i++)
          if (this.vendedores[i].id == comprobante.vendedor_id) {
            this.selectedVendedor = this.vendedores[i];
            break;
          }
        if (this.form.tipo_comprobante_afectado === this.codigoProforma) {
          this.form.formasPago = [];
          for (let i = 0; i < comprobante.formas_pago.length; i++)
            this.form.formasPago.push({
              plazo: comprobante.formas_pago[i].plazo,
              unidad_tiempo: comprobante.formas_pago[i].unidad_tiempo,
              valor: comprobante.formas_pago[i].total,
              selectedFormaPago: comprobante.formas_pago[i].forma_pago,
            });
        }
      }
      this.form.informacionAdicional = [];
      for (let i = 0; i < comprobante.detalles_adicionales.length; i++)
        this.form.informacionAdicional.push({
          nombre_campo: comprobante.detalles_adicionales[i].nombre,
          valor_campo: comprobante.detalles_adicionales[i].valor,
          enviar_sri: comprobante.detalles_adicionales[i].enviar_sri === "S",
          final: comprobante.detalles_adicionales[i].final
        });
      for (let i = 0; i < comprobante.items.length; i++) {
        let item = {
          cantidad: comprobante.items[i].cantidad,
          precio: comprobante.items[i].precio_unitario,
          nombre_item:
            comprobante.items[i].descripcion != null &&
              comprobante.items[i].descripcion != ""
              ? comprobante.items[i].descripcion
              : comprobante.items[i].descripcion_item,
          total_descuento: comprobante.items[i].descuento,
          total_parcial: comprobante.items[i].precio_total_sin_imp,
          id_item: comprobante.items[i].id_item,
          total_impuestos: 0,
          total: parseFloat(comprobante.items[i].precio_total_sin_imp),
          precio_produccion: comprobante.items[i].item.precio_produccion,
          irbpnr: comprobante.items[i].item.irbpnr === "S",
          total_irbpnr: 0,
          cantidad_ice: comprobante.items[i].item.cantidad_ice,
          cantidad_irbpnr: comprobante.items[i].item.cantidad_irbpnr,
          ice: 0,
          id_ice: "",
          detalle: "",
          valor_subsidio: comprobante.items[i].valor_subsidio,
          precio_sin_subsidio: comprobante.items[i].precio_sin_subsidio,
          mostrar_detalle: comprobante.items[i].mostrar_detalle === "S",
          coste:
            comprobante.items[i].coste !== null
              ? comprobante.items[i].coste
              : comprobante.items[i].item.costo,
          margen_utilidad: 0,
          tipo_item: comprobante.items[i].item.tipo_item,
          iva_incluido_precio:
            comprobante.items[i].item.iva_incluido_precio === "S",
        };
        if (item.irbpnr)
          item.total_irbpnr =
            parseFloat(this.irbpnr) * parseFloat(item.cantidad);
        if (isNaN(item.total_irbpnr)) item.total_irbpnr = 0;
        for (let j = 0; j < comprobante.items[i].impuestos.length; j++) {
          if (
            comprobante.items[i].impuestos[j].id_impuesto === this.codigoIva
          ) {
            item.id_iva = comprobante.items[i].impuestos[j].id_tarifa;
            item.iva = comprobante.items[i].impuestos[j].valor;
            item.porcentaje_iva = comprobante.items[i].impuestos[j].porcentaje;
          } else if (
            comprobante.items[i].impuestos[j].id_impuesto === this.codigoIce
          ) {
            item.id_ice = comprobante.items[i].impuestos[j].id_tarifa;
            item.ice = comprobante.items[i].impuestos[j].valor;
            item.porcentaje_ice = comprobante.items[i].impuestos[j].porcentaje;
            item.numero_unidades_ice =
              comprobante.items[i].item.numero_unidades_ice;
            item.tarifa_especifica_ice =
              comprobante.items[i].item.tarifa_especifica;
            item.porcentaje_ed_valorem =
              comprobante.items[i].item.porcentaje_ed_valorem;
          }
          let iva = parseFloat(item.iva);
          let ice = parseFloat(item.ice);
          item.total_impuestos +=
            (isNaN(iva) ? 0 : iva) + (isNaN(ice) ? 0 : ice) + item.total_irbpnr;
        }
        if (comprobante.items[i].detalles_adicionales.length > 0)
          item.detalle = comprobante.items[i].detalles_adicionales[0].valor;
        item.total += parseFloat(item.total_impuestos);
        let index = this.form.items.push(item) - 1;
        this.$refs.tablaDetalleComprobante.calcularUtilidadFila(
          index,
          this.form.items
        );
      }
      this.$modal.hide("listaComprobantes");
      this.clonComprobante = null;
      this.calcularTotales();
      this.calcularUtilidad();
    },
    calcularTotales: function () {
      let irbpnr = 0;
      let totalSinImpuestos = 0;
      let iva = 0;
      let ice = 0;
      let descuento = 0;
      let subtotalNoIva = 0;
      let subtotalExIva = 0;
      let subtotalIva0 = 0;
      let subtotalIva = 0;
      let porcIva = 0;
      for (let i = 0; i < this.form.items.length; i++) {
        iva += parseFloat(this.form.items[i].iva);
        ice += parseFloat(this.form.items[i].ice);
        irbpnr += parseFloat(this.form.items[i].total_irbpnr);
        let desc = parseFloat(this.form.items[i].total_descuento);
        if (!isNaN(desc)) descuento += desc;
        totalSinImpuestos += parseFloat(this.form.items[i].total_parcial);
        if (this.form.items[i].id_iva === this.ivaNoObjeto)
          subtotalNoIva += parseFloat(this.form.items[i].total_parcial);
        if (this.form.items[i].id_iva === this.ivaExento)
          subtotalExIva += parseFloat(this.form.items[i].total_parcial);
        if (this.form.items[i].id_iva === this.ivaCero)
          subtotalIva0 += parseFloat(this.form.items[i].total_parcial);
        if (this.form.items[i].iva > 0) {
          subtotalIva += parseFloat(this.form.items[i].total_parcial);
          porcIva = parseFloat(this.form.items[i].porcentaje_iva);
          if (isNaN(porcIva)) porcIva = 0;
        }
      }
      //totalSinImpuestos += descuento;
      this.form.subtotal_iva_0 = round(subtotalIva0);
      this.form.subtotal_exento_iva = round(subtotalExIva);
      this.form.total_sin_impuestos = round(totalSinImpuestos);
      //iva=round(subtotalIva) * 0.12;
      if (!this.calcular_totales_final) this.form.iva = round(iva);
      else {
        iva = round(subtotalIva * (porcIva / 100));
        this.form.iva = round(iva);
      }
      this.form.ice = round(ice);
      this.form.total_irbpnr = round(irbpnr);
      this.form.descuento_total = round(descuento);
      this.form.subtotal_no_sujeto_iva = round(subtotalNoIva);
      this.form.subtotal_iva = round(subtotalIva);
      let fleteInternacional = parseFloat(this.form.v_flete_internacional);
      if (isNaN(fleteInternacional))
        fleteInternacional = 0;
      let seguroInternacional = parseFloat(this.form.v_seguro_internacional);
      if (isNaN(seguroInternacional))
        seguroInternacional = 0;
      let gastosAduaneros = parseFloat(this.form.v_gastos_aduaneros);
      if (isNaN(gastosAduaneros))
        gastosAduaneros = 0;
      let gastosTransporte = parseFloat(this.form.v_gastos_transporte_otros);
      if (isNaN(gastosTransporte))
        gastosTransporte = 0;
      this.form.total = round(
        round(totalSinImpuestos) + round(iva) + round(ice) + round(irbpnr)
        + fleteInternacional + seguroInternacional + gastosAduaneros + gastosTransporte
      );
    },
    verificarFirma: function () {
      axios.get(url + '/verificar-firma').then(({data}) => {
        if(data.cambiarFirma) {
          swal('La firma electrónica requiere ser actualizada o configurada.', 'Aviso', 'warning');
        }
      }).catch(() => {
        swal('Hubo un error.', 'Error', 'error');
      });
    },
    guardarComprobante: function () {
      if (this.tipoComprobante === this.codigoFactura && this.form.factura_exterior) {
        if (this.form.incoterm_factura == '') {
          swal.fire('Debe seleccionar el incoterm de la factura', 'Aviso', 'warning');
          return;
        }
        if (this.selectedCiudad == null) {
          swal.fire('Debe seleccionar el lugar incoterm de la factura', 'Aviso', 'warning');
          return;
        }
        if (this.selectedCiudadEmbarque == null) {
          swal.fire('Debe seleccionar el puerto de embarque de la factura', 'Aviso', 'warning');
          return;
        }
        if (this.selectedPuertoDestino == null) {
          swal.fire('Debe seleccionar el puerto de destino de la factura', 'Aviso', 'warning');
          return;
        }
        if (this.form.incoterm_total_si == '') {
          swal.fire('Debe seleccionar el incoterm del total sin impuestos de la factura', 'Aviso', 'warning');
          return;
        }
      }
      let monto_maximo_cf = parseFloat(this.monto_maximo_cf);
      if (isNaN(monto_maximo_cf)) {
        monto_maximo_cf = 0;
      }
      let total = parseFloat(this.form.total);
      if (isNaN(total)) total = 0;
      if (
        this.tipoComprobante === this.codigoFactura &&
        this.numero_identificacion === "9999999999999"
      ) {
        if (total > monto_maximo_cf) {
          swal(
            "El monto máximo no debe exceder: " +
            moneyFormat(monto_maximo_cf) +
            " para el consumidor final.",
            "Aviso",
            "warning"
          );
          return;
        }
      }
      this.errores = {};
      if (this.tipoComprobante === this.codigoFactura) {
        let totalPagos = 0;
        for (let i = 0; i < this.form.formasPago.length; i++) {
          let valor = parseFloat(this.form.formasPago[i].valor);
          if (isNaN(valor)) valor = 0;
          totalPagos += valor;
        }
        if (totalPagos !== parseFloat(this.form.total)) {
          swal(
            "El pago total debe ser igual al valor final del comprobante.",
            "Aviso",
            "warning"
          );
          return;
        }
      }
      let that = this;
      let urlRequest = this.url + "/comprobantes";
      if (this.estado !== "N") {
        this.form._method = "PUT";
        urlRequest += "/" + this.id_comprobante;
      } else this.form._method = undefined;
      axios
        .post(urlRequest, this.form)
        .then(function (response) {
          that.id_comprobante = response.data.id_comprobante;
          that.numero_comprobante =
            response.data.codigo_establecimiento +
            "-" +
            response.data.codigo_emisor +
            "-" +
            response.data.numero_secuencial;
          that.estado = response.data.id_estado_comprobante;
          if (that.selectedPuntoEmision.tipo === "E")
            that.clave_acceso = response.data.clave_acceso;

          if (that.selectedPuntoEmision.autorizar_automatico == 'S')
            that.enColaAutorizacion = true;
          swal({
            title:
              "El comprobante fue almacenado con éxito. ¿Deseas imprimir el comprobante?",
            text: "Esta acción requiere de confirmación.",
            type: "question",
            showCancelButton: true,
            confirmButtonText: "Imprimir",
            cancelButtonText: "No",
          }).then((result) => {
            if (result.value) that.imprimirComprobante();
          });
        })
        .catch(function (error) {
          if (error !== null && error !== undefined) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              if (response.status === 422) {
                that.errores = response.data.errors;
                swal("Hay errores de validación.", "Aviso", "warning");
              } else if (response.status === 403)
                swal(
                  "El punto de emisión manual ha llegado a su límite o ha expirado, por favor, actualice la secuencia del mismo.",
                  "Aviso",
                  "warning"
                );
              else if(response.status === 524)
                swal(response.data.mensaje, 'Error', 'error');
              else if (response.status !== 404)
                swal("Hubo un error, intente nuevamente.", "Error", "error");
              else
                swal(
                  "Error de duplicidad, intente nuevamente.",
                  "Error",
                  "warning"
                );
            }
          }
        });
    },
  },
  mounted: function () {
    this.cargarDatosFormulario();
    this.verificarFirma();
  },
  watch: {
    selectedPuntoEmision: function (value) {
      if (value !== undefined && value !== null) {
        this.form.id_punto_emision = value.id;
        if (this.estado === "N" && value.tipo === "M") {
          this.form.numero_autorizacion = value.numero_autorizacion;
          this.form.fecha_autorizacion = moment(
            new Date(value.fecha_autorizacion)
          ).format("YYYY-MM-DD");
        } else if (this.estado === "N") {
          this.form.numero_autorizacion = "";
          this.form.fecha_autorizacion = null;
        }
      } else this.form.id_punto_emision = "";
      if (value.nombre_campo != null && value.valor_campo != null) {
        let arCampo = value.nombre_campo.split(';;');
        let arValorCampo = value.valor_campo.split(';;');
        if (arCampo.length == arValorCampo.length) {
          for (let i = 0; i < arCampo.length; i++) {
            let nombreCampo = arCampo[i];
            let valorCampo = arValorCampo[i];
            let infoCampo = this.obtenerInformacionAdicional(nombreCampo);
            if (infoCampo === null)
              this.form.informacionAdicional.push({
                nombre_campo: nombreCampo,
                valor_campo: valorCampo,
                enviar_sri: true,
                final: 'S'
              });
          }
        }
      }

      this.cargarNumeroActual();
    },
    selectedMoneda: function (value) {
      if (value !== undefined && value !== null)
        this.form.id_moneda = value.id_moneda;
      else this.form.id_moneda = "";
    },
    selectedTipoEmision: function (value) {
      if (value !== undefined && value !== null)
        this.form.id_tipo_emision = value.id_tipo_emision;
      else this.form.id_tipo_emision = "";
    },
    selectedVendedor: function (value) {
      if (value !== undefined && value !== null)
        this.form.vendedor_id = value.id;
      else this.form.vendedor_id = "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/Comprobante.vue